import React, { FC, useMemo } from 'react';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import {
    WalletModalProvider,
} from '@solana/wallet-adapter-react-ui';

// Default styles that can be overridden by your app
import '@solana/wallet-adapter-react-ui/styles.css';

// Use QuickNode RPC for reliable Solana access (configured via VITE_SOLANA_RPC_URL)
// Set VITE_SOLANA_RPC_URL in environment variables to use your QuickNode endpoint
// Falls back to public RPC if not configured
const SOLANA_RPC_ENDPOINT = import.meta.env.VITE_SOLANA_RPC_URL || "https://api.mainnet-beta.solana.com";

export const SolanaWalletProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
    const endpoint = useMemo(() => SOLANA_RPC_ENDPOINT, []);

    // Empty array - Phantom and other wallets now register as Standard Wallets automatically
    // This removes the "Phantom was registered as a Standard Wallet" warning
    const wallets = useMemo(() => [], []);

    return (
        <ConnectionProvider endpoint={endpoint}>
            <WalletProvider wallets={wallets} autoConnect>
                <WalletModalProvider>
                    {children}
                </WalletModalProvider>
            </WalletProvider>
        </ConnectionProvider>
    );
};
